import { InitPagedData } from './../Utils';
import {MaterialStateTypes,MaterialActionTypes } from "./Material.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MaterialStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
  fetchPaged:resetApiCallState(InitPagedData)
};

const MaterialReducer = (
  state: MaterialStateTypes = INITIAL_STATE,
  action: any
): MaterialStateTypes => {
  switch (action.type) {
    case MaterialActionTypes.FETCH_ALL_MATERIAL:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialActionTypes.FETCH_ALL_MATERIAL_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialActionTypes.FETCH_ALL_MATERIAL_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialActionTypes.FETCH_ALL_MATERIAL_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };
      case MaterialActionTypes.FETCH_PAGED_MATERIAL:
        return {
          ...state,
          fetchPaged: {
            error: null,
            payload: InitPagedData,
            isPending: true,
            isSuccessful: false,
          },
        };
      case MaterialActionTypes.FETCH_PAGED_MATERIAL_RESET:
        return {
          ...state,
          fetchPaged: resetApiCallState(InitPagedData),
        };
      case MaterialActionTypes.FETCH_PAGED_MATERIAL_FAILURE:
        return {
          ...state,
          fetchPaged: {
            payload: InitPagedData,
            isPending: false,
            isSuccessful: false,
            error: action.payload,
          },
        };
      case MaterialActionTypes.FETCH_PAGED_MATERIAL_SUCCESS:
        return {
          ...state,
          fetchPaged: {
            error: null,
            isPending: false,
            isSuccessful: true,
            payload: action.payload,
          },
        };

    case MaterialActionTypes.FETCH_ONE_MATERIAL:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialActionTypes.FETCH_ONE_MATERIAL_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialActionTypes.FETCH_ONE_MATERIAL_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialActionTypes.FETCH_ONE_MATERIAL_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default MaterialReducer;
